import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { AppAsyncOfficesAutocomplete, AppFormGrid, AppMoreOptions } from "@components"
import { Box } from "@mui/material"
import { useSignal } from "@preact/signals-react"

export default function OneWayRoutesField() {

	const showOneWays = useSignal(!!reportFormData.peek()?.oneWayRoutes?.length)

	const {
		oneWayRoutes,
		setOneWayRoutesInfo,
		error
	} = useReportFormInfo(reportFormData.peek().oneWayRoutes, "oneWayRoutes", object({ oneWayRoutes: array() }))

	return <AppMoreOptions label="One way routes" open={showOneWays.value} onToggle={() => showOneWays.value = !showOneWays.value}>
		<AppFormGrid>
			<Box sx={{ gridColumn: 'span 8' }}>
				<AppAsyncOfficesAutocomplete
					multiple
					label="One Way Office Routes"
					placeholder="Select One Way Office Routes"
					value={oneWayRoutes || []}
					error={error}
					onChange={e => setOneWayRoutesInfo(e.target.value)}
				/>
			</Box>
		</AppFormGrid>
	</AppMoreOptions>
}
